import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    IGetConfig,
    SystemEntity,
    UserAction,
} from '@wdx/shared/utils';

const USER_ACTION_ENTITIES: SystemEntity[] = [
    SystemEntity.Person,
    SystemEntity.Organisation,
    SystemEntity.Client,
    SystemEntity.Intermediary,
    SystemEntity.Lead,
    SystemEntity.Adviser,
    SystemEntity.Article,
    SystemEntity.Activity,
    SystemEntity.Process,
    SystemEntity.Case,
    SystemEntity.Opportunity,
    SystemEntity.Document,
];

@Injectable()
export class UserActionHttpService {
    constructor(
        private http: HttpClient,
        private config: IGetConfig,
    ) {}

    sendAction(
        action: UserAction | SystemEntity,
        entity: SystemEntity,
        id: string,
    ): void {
        if (!USER_ACTION_ENTITIES.includes(entity)) {
            return;
        }
        this.http
            .patch<void>(
                `${
                    this.config.getConfiguration().API_BASE
                }/useraction/${action.toLowerCase()}/entity/${entity.toLowerCase()}/${id}`,
                {},
            )
            .subscribe();
    }
}
